export const PLANNING_SETTINGS_COPY = {
  tabsLabel: "Planning settings",
  title: "Planning",
  generalTab: "General",
  agentTab: "Agent",
  automationTab: "Automation",
  autoStartLabel: "Auto-start",
  autoStartReviewHelper: "Auto-start tasks when the first score is 3/3.",
  autoStartPlanningOffHelper: "Resume planning to use Auto-start.",
  autoStartNoBoardHelper: "Set up a board before you turn Auto-start on.",
  save: "Save",
  saving: "Saving",
  saveError: "Could not save Planning settings.",
  loading: "Loading Planning settings.",
  loadError: "Could not load Planning settings.",
  retry: "Retry",
  automationEmpty: "This automation has no steps yet.",
  automationLoading: "Loading the steps.",
  automationError: "Could not load the steps.",
} as const;
